import { classNames } from 'primereact/utils';

import { CertificateEnclosedSite } from '../../shared/interfaces/ICertificate';

type EnclosedSitesGridProps = {
  sites?: CertificateEnclosedSite[];
  emptyText: string;
};

const EnclosedSitesGrid = ({ sites = [], emptyText }: EnclosedSitesGridProps): JSX.Element => {
  if (!sites.length) {
    return <span className='font-light text-black-alpha-60'>{emptyText}</span>;
  }

  const siteRows: CertificateEnclosedSite[][] = [];

  for (let i = 0; i < sites.length; i += 2) {
    siteRows.push(sites.slice(i, i + 2));
  }

  return (
    <div className='flex flex-column gap-4'>
      {siteRows.map((row, rowIndex) => {
        return (
          <div key={`enclosed-site-row-${rowIndex}`} className='grid grid-nogutter gap-4 md:gap-0'>
            {row.map((site, siteIndex) => {
              return (
                <div
                  key={site.id}
                  className={classNames('col-12 md:col flex flex-column gap-1 md:gap-2', {
                    'md:pr-4': siteIndex === 0,
                  })}
                >
                  <span className='font-medium'>{site.name}</span>
                  <span className='font-light text-black-alpha-60 text-sm'>{site.bpns}</span>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default EnclosedSitesGrid;
